import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { defaultConfiguration } from '@mmx/shared'

import {
  ServiceReviewSubmissionDialogData,
} from '../service-review-submission-dialog'

@Component({
  selector: 'mmx-service-review-submission-preview',
  templateUrl: './service-review-submission-preview.component.html',
  styleUrls: ['./service-review-submission-preview.component.scss'],
  standalone: false,
})
export class ServiceReviewSubmissionPreviewComponent {
  public readonly configuration = defaultConfiguration

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ServiceReviewSubmissionDialogData,
  ) {}
}
